import classNames from 'classnames';
import Logo from 'components/common/Logo';
import apiClient from 'helpers/apiService';
import { PropsWithChildren, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface AuthSimpleLayoutProps {
  logo?: boolean;
  className?: string;
}

const AuthSimpleLayout = ({
  logo = true,
  className = 'col-xl-5 col-xxl-3',
  children
}: PropsWithChildren<AuthSimpleLayoutProps>) => {

  const [version, setVersion] = useState<string>('');

  const fetchContacts = async () => {
    const { data } = await apiClient.get(`/`);
    setVersion(data.release_at);
  };

  useEffect(() => {

    fetchContacts();

  });


  return (
    <div className="container">
      <Row className="flex-center py-5" style={{ minHeight: '95vh' }}>
        <Col sm={10} md={8} lg={5} className={classNames(className)}>
          {logo && (
            <Link
              to="https://www.theach.ai"
              className="d-flex flex-center text-decoration-none mb-4"
            >
              <Logo
                text={false}
                width={58}
                className="fw-bolder fs-5 d-inline-block"
              />
            </Link>
          )}
          {children}
        </Col>
      </Row>
      <Row className="flex-end-center" style={{ minHeight: '5vh' }}>
        Last release: {version}
      </Row>

    </div >
  );
};

export default AuthSimpleLayout;
